<div class="rules-action-item">
    <!-- variable list -->
    <div class="actions">
        <div class="action-select">
            <settings-rules-rule-form-helper-select
                [options]="availableActions"
                [optionSelected]="actionForm.key"
                (actionSelect)="onSelectAction($event)"
            ></settings-rules-rule-form-helper-select>
            <div class="action-deprecated" *ngIf="actionForm.id == null">
                <span>This action is no longer available, please replace it with an new action.</span>
            </div>
        </div>
    </div>

    <div class="button-actions-add">
        <core-helpers-forms-button-icon [text]="'Add action'" (click)="addAction()" [icon]="'add'"></core-helpers-forms-button-icon>
        <span (click)="removeAction()" class="action-remove">Remove</span>
    </div>
</div>

<div class="rules-actions-nested">
    <!-- <p>  available variable {{availableActionVariables.length}}  </p> -->
    <settings-rules-rule-form-actions-variable-item
        *ngFor="let availableVariable of availableActionVariables"
        [ruleActionsConfigured]="currentRuleAction" 
        [actionForm]="actionForm"
        [variable]="getCurrentActionVariable(availableVariable.key)"
        [availableVariables]="availableActionVariables"
        (selectValue)="selectVariable($event)"
    ></settings-rules-rule-form-actions-variable-item>
</div>
